<template>
  <div class="main">
    <report-top> </report-top>
    <selectTool ref="selectTool">
      <template slot="text">报警推送规则列表</template>
      <template slot="btn"
        ><Button @click="getList" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openBlind(row)"> 绑定 </Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      width="700"
      ref="formModel"
      :title="isAdd ? '新增规则' : '编辑规则'"
      ><Alert type="error" slot="accountList">
        <span slot="desc"
          >请需要接收通知的用户关注公众号并登录小程序授权，</span
        >
        <a v-if="false" slot="desc" @click="openPic = true">开始操作</a>
      </Alert>
      <Button slot="btn" type="primary" @click="addUpdate">确认修改</Button>
    </form-model>
    <blind ref="blind" v-model="deviceList" @blind="blind"></blind>
    <Modal
      width="400"
      footer-hide
      title="将以下二维码截图发给接收人"
      v-model="openPic"
    >
      <ul id="eeweima">
        <li>
          <img width="100" src="static/e/gongzhonghao.jpg" />
          <p>来源电子公众号</p>
        </li>
        <li>
          <img width="100" src="static/e/xiaochengxu.jpg" />
          <p>来源gps小程序</p>
        </li>
      </ul>
    </Modal>
  </div>
</template>
<script>
var categorys = [];
var users = [];
var noticeTypes = [];
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },

        {
          title: "创建者账号",
          key: "createAccount",
          sort: 33,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 34,
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
          sort: 35,
        },
      ],
      tableData: [],
      item: {
        enabled: true,
        name: "",
        typeList: [1, 2],
        accountList: [],
        alarmList: [],
        groupId: "",
        groupName: "",
        mailList: [],
        otherConfig: [],
        remark: "",
        telList: [],
      },
      forms: [
        {
          title: "类型名称",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
        },
        {
          title: "报警类型",
          key: "alarmList",
          multiple: true,
          noTable: true,
          type: "Select",
          selectItems: categorys,
          span: 24,
        },
        {
          title: "通知用户",
          key: "accountList",
          slotForm: "accountList",
          type: "Select",
          selectType: "obj",
          multiple: true,
          filterable: true,
          allowCreate: false,
          noTable: true,
          selectItems: users,
          span: 24,
        },
        {
          title: "推送类型",
          key: "typeList",
          type: "checkbox",
          selectType: "obj",
          selectItems: [
            { id: 1, name: "站内" },
            { id: 2, name: "微信" },
          ],
          noTable: true,
          required: true,
        },
        {
          title: "是否启用",
          key: "enabled",
          type: "bool",
          noTable: true,
        },
        {
          title: "备注",
          key: "remark",
          type: "Input",
        },
      ],

      total: 0,
      deviceList: [],
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [],
      openPic: false,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      console.log(this.searchItem);
      this.axios({
        method: "post",
        url: this.axios.rule + "/pushAlarm/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
        console.log(data);
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      console.log(this.item);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.rule + "/pushAlarm/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.rule + "/pushAlarm/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.rule + "/pushAlarm/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.getUserTree();
      this.getAlarmType();
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
      this.getItem(row, 1);
    },
    openAdd() {
      this.getUserTree();
      this.getAlarmType();
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },

    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    getItem(row, type) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/pushAlarm/item",
        data: { id: row.id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          if (type == 1) {
            var data = res.data.data.fenceRuleList;
            var arr = [];

            for (let i = 0; i < data.length; i++) {
              arr.push(data[i].id);
            }
            this.item.fenceRuleIdList = arr;
            this.openForm = true;
          } else {
            console.log(res.data.data);
            var d = res.data.data.deviceList;
            this.deviceList = [];
            for (let i = 0; i < d.length; i++) {
              var obj = {
                id: d[i].deviceId,
                name: d[i].bindAttr,
                key: d[i].deviceId,
                useType: d[i].useType,
              };
              this.deviceList.push(obj);
            }
            this.$refs.blind.open(row);
          }
        }
      });
    },
    openBlind(row) {
      this.getItem(row);
      this.blindId = row.id;
    },
    blind(data) {
      this.utils.loading(this, "处理中");
      var deviceIdList = [];
      for (let i = 0; i < data.length; i++) {
        deviceIdList.push(data[i].id);
      }
      this.axios({
        method: "post",
        url: this.axios.rule + "/pushAlarm/bind",
        data: { deviceIdList: deviceIdList, id: this.blindId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
      });
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    getUserTree() {
      this.axios({
        method: "post",
        url: this.axios.bm + "/user/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        users.length = 0;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            name: data[i].account,
            id: data[i].accountId,
          };
          users.push(obj);
        }
      });
    },
    getAlarmType() {
      this.axios({
        method: "post",
        url: "/dictionary/item",
        data: {
          keyword: "alarmPush",
        },
      }).then((res) => {
        var a = JSON.parse(res.data.data.value);

        categorys.splice(0, 100);
        for (const i in a) {
          categorys.push(a[i].name);
        }
      });
    },
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
#eeweima {
  display: flex;
}
#eeweima li {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/rule/rulePushAlarm.vue